<template>
  <ArticleForm is-edit />
</template>

<script>
import ArticleForm from '@/layouts/components/form/ArticleForm.vue'

export default {
  components: { ArticleForm },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
